(function () {
  'use strict';

  // Teshis anahtari: ?btpro_bundle=off ile bu ozel tasarim tamamen devre disi kalir,
  // eklentinin kendi arayuzu gorunur. Bir hatanin bizden mi eklentiden mi geldigini ayirmak icin.
  if (location.search.indexOf('btpro_bundle=off') !== -1) return;

  // -------------------------------------------------------------------
  // i18n: Dil tespiti ve çeviriler
  // -------------------------------------------------------------------
  var TRANSLATIONS = {
    ar: {
      bundleDiscount: 'خصم الحزمة',
      descText: 'وفّر أكثر بإضافة منتجات من نفس المجموعة إلى سلة التسوق',
      productsSelected: function (n) { return n + ' ' + (n === 1 ? 'منتج محدد' : 'منتجات محددة'); },
      totalPrice: 'السعر الإجمالي'
    },
    en: {
      bundleDiscount: 'Bundle Discount',
      descText: 'Save more by adding items from the same collection to your cart',
      productsSelected: function (n) { return n + ' Product' + (n !== 1 ? 's' : '') + ' Selected'; },
      totalPrice: 'Total Price'
    }
  };

  function getLang() {
    var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return TRANSLATIONS[lang] ? lang : 'en';
  }

  function t(key, arg) {
    var tr = TRANSLATIONS[getLang()][key];
    return typeof tr === 'function' ? tr(arg) : tr;
  }

  // -------------------------------------------------------------------
  // Ortak: Kart DOM'u oluştur
  // -------------------------------------------------------------------
  // "+" — bordersız, sadece çizgiler
  var PLUS_SVG =
    '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M9.5 2V17M2 9.5H17" stroke="#BBBBBB" stroke-width="1.8" stroke-linecap="round"/>' +
    '</svg>';

  function buildCard(opts) {
    // opts: { imgSrc, imgAlt, name, price, variantCont, checkboxInput, isDisabled, isChecked }
    var card = document.createElement('div');
    card.className = 'btpro-bundle-card';

    if (opts.isDisabled) card.classList.add('btpro-card--trigger');
    if (opts.isDisabled) card.classList.add('btpro-card--main');
    if (!opts.isChecked && !opts.isDisabled) card.classList.add('btpro-card--unchecked');

    // Resim kapsayıcı (edge-to-edge, padding yok)
    var imgCont = document.createElement('div');
    imgCont.className = 'btpro-bundle-card-img-cont';

    if (opts.imgSrc) {
      var newImg = document.createElement('img');
      newImg.src = opts.imgSrc;
      newImg.alt = opts.imgAlt || '';
      newImg.className = 'btpro-bundle-card-img';
      imgCont.appendChild(newImg);
    }

    // Checkbox overlay (sağ üst, trigger hariç)
    if (!opts.isDisabled && opts.checkboxInput) {
      var overlay = document.createElement('div');
      overlay.className = 'btpro-card-check-overlay' + (opts.isChecked ? ' btpro-card-check-overlay--checked' : '');
      overlay.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
      var _input = opts.checkboxInput;
      overlay.addEventListener('click', function () { _input.click(); });
      imgCont.appendChild(overlay);
    }

    // Variant seçici → resmin içinde, sağ alt (absolute)
    // ÖNEMLİ: klonlanmıyor, orijinal element taşınıyor. cloneNode() eklentinin kendi event
    // listener'larını kopyalamadığı için klon üzerinden beden değiştirmek fiyatı güncellemiyordu.
    // Element hâlâ <lb-bundle> içinde kaldığı için eklentinin kendi sorguları bozulmuyor.
    if (opts.variantCont) {
      var pickerWrap = document.createElement('div');
      pickerWrap.className = 'btpro-bundle-card-picker';
      pickerWrap.appendChild(opts.variantCont);
      imgCont.appendChild(pickerWrap);
    }

    card.appendChild(imgCont);

    // Alt bilgi alanı (isim + fiyat)
    var infoArea = document.createElement('div');
    infoArea.className = 'btpro-bundle-card-info';

    if (opts.name) {
      var nameEl = document.createElement('div');
      nameEl.className = 'btpro-bundle-card-name';
      nameEl.textContent = opts.name;
      infoArea.appendChild(nameEl);
    }

    if (opts.price) {
      var priceEl = document.createElement('div');
      priceEl.className = 'btpro-bundle-card-price';
      priceEl.textContent = opts.price;
      infoArea.appendChild(priceEl);
    }

    card.appendChild(infoArea);

    return card;
  }

  // -------------------------------------------------------------------
  // Ortak: Sağ panel oluştur
  // -------------------------------------------------------------------
  function buildDiscountPanel(opts) {
    // opts: { discountText, descText, selectedCount, totalPrice, btnEl, bundle }

    // Mobil üst başlık (badge + desc) — masaüstünde gizlenir
    var headerEl = document.createElement('div');
    headerEl.className = 'btpro-bundle-panel-header';
    headerEl.innerHTML =
      '<div class="btpro-discount-badge">' + opts.discountText + '</div>' +
      '<p class="btpro-discount-desc">' + (opts.descText || t('descText')) + '</p>';

    // Ana panel (masaüstünde sağ panel; mobilde meta + buton kutusu)
    var panel = document.createElement('div');
    panel.className = 'btpro-bundle-discount-panel';

    var HEART_BG_SVG =
      '<svg class="btpro-frame-bg-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">' +
      '<path d="M100 160 C60 130 10 100 10 55 C10 25 35 5 65 5 C80 5 92 12 100 22 C108 12 120 5 135 5 C165 5 190 25 190 55 C190 100 140 130 100 160Z" fill="currentColor"/>' +
      '</svg>';

    panel.innerHTML =
      '<div class="btpro-discount-frame">' +
      HEART_BG_SVG +
      '<div class="btpro-discount-badge btpro-badge--desktop">' + opts.discountText + '</div>' +
      '<p class="btpro-discount-desc btpro-desc--desktop">' + (opts.descText || t('descText')) + '</p>' +
      '<div class="btpro-discount-meta">' +
      '<span class="btpro-discount-count">' + t('productsSelected', opts.selectedCount) + '</span>' +
      '<div class="btpro-discount-total-label">' + t('totalPrice') + '</div>' +
      '<div class="btpro-discount-total-price">' + (opts.totalPrice || '') + '</div>' +
      '</div>' +
      '</div>';

    if (opts.btnEl) {
      var btnClone = document.createElement('button');
      btnClone.className = 'btpro-bundle-btn';
      btnClone.type = 'button';
      btnClone.textContent = opts.btnEl.textContent.trim();
      btnClone.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        opts.btnEl.click();

        setTimeout(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.addEventListener('cart-drawer:refreshed', function onRefreshed() {
              cartDrawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
              cartDrawer.show();
            });
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }, 800);
      });
      panel.querySelector('.btpro-discount-frame').appendChild(btnClone);
    }

    panel._headerEl = headerEl;
    return panel;
  }

  // -------------------------------------------------------------------
  // Ortak: Layout'u DOM'a ekle + observer başlat
  // -------------------------------------------------------------------
  function insertLayout(hideEl, cardGrid, discountPanel, bundle, infoItems, cardEls, ctaHost) {
    var layoutWrap = document.createElement('div');
    layoutWrap.className = 'btpro-bundle-layout';
    // Mobil üst başlık (kart grid'inden önce)
    if (discountPanel._headerEl) layoutWrap.appendChild(discountPanel._headerEl);
    layoutWrap.appendChild(cardGrid);
    layoutWrap.appendChild(discountPanel);

    hideEl.style.display = 'none';
    hideEl.insertAdjacentElement('afterend', layoutWrap);

    // Offer kartlarını scroll track'e taşı (mobil swiper için)
    var offerCards = Array.from(cardGrid.querySelectorAll('.btpro-card--offer'));
    if (offerCards.length) {
      var offerTrack = document.createElement('div');
      offerTrack.className = 'btpro-offer-scroll-track';
      offerCards.forEach(function (c) { offerTrack.appendChild(c); });
      var plusEl = cardGrid.querySelector('.btpro-bundle-plus');
      if (plusEl) plusEl.insertAdjacentElement('afterend', offerTrack);
      else cardGrid.appendChild(offerTrack);
    }

    // "+" öğesini resmin ortasına hizala (kart genişliği = resim yüksekliği, aspect-ratio 1/1)
    alignPlusSign(cardGrid);
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { alignPlusSign(cardGrid); });
      ro.observe(cardGrid);
    }

    observeSelectionChanges(bundle, discountPanel, infoItems, cardEls, ctaHost);
  }

  function alignPlusSign(cardGrid) {
    var plusEl = cardGrid.querySelector('.btpro-bundle-plus');
    var firstCard = cardGrid.querySelector('.btpro-bundle-card');
    if (!plusEl || !firstCard) return;
    var imgCont = firstCard.querySelector('.btpro-bundle-card-img-cont');
    if (!imgCont) return;
    var imgH = imgCont.offsetHeight;
    if (imgH > 0) {
      plusEl.style.marginTop = Math.round(imgH / 2 - 10) + 'px';
    }
  }

  // -------------------------------------------------------------------
  // TİP 1: lb-classic
  // -------------------------------------------------------------------
  function applyClassicDesign(bundle) {
    var imageRow = bundle.querySelector('.lb-bundle-classic-image-row');
    var infoItems = bundle.querySelectorAll('.lb-bundle-classic-info-item');
    var classicEl = bundle.querySelector('.lb-bundle-classic');
    var ctaHost = bundle.querySelector('lb-bundle-cta');

    if (!imageRow || !infoItems.length || !classicEl) {
      setTimeout(function () { applyBundleDesign(bundle); }, 300);
      return false;
    }

    // lb-card-image web component'ları henüz hydrate edilmemiş olabilir → retry
    var cardImages = imageRow.querySelectorAll('lb-card-image');
    if (!cardImages.length) {
      setTimeout(function () { applyBundleDesign(bundle); }, 300);
      return false;
    }

    var cardGrid = document.createElement('div');
    cardGrid.className = 'btpro-bundle-card-grid';
    var cardEls = [];

    cardImages.forEach(function (imgHost, i) {
      var infoItem = infoItems[i];
      var checkboxInput = infoItem ? infoItem.querySelector('input[type="checkbox"]') : null;
      // i===0 her zaman trigger/ana üründür; checkbox.disabled kontrolü yedek olarak eklenir
      var isDisabled = i === 0 || (checkboxInput ? checkboxInput.disabled : false);
      var isChecked = infoItem ? !!infoItem.querySelector('.lb-custom-checkbox.lb-checked') : false;
      var imgEl = imgHost.querySelector('img');
      var titleNode = infoItem ? infoItem.querySelector('.lb-card-title') : null;
      var variantCont = infoItem ? infoItem.querySelector('.lb-variant-picker-cont') : null;
      var priceNode = infoItem ? infoItem.querySelector('.lb-price-sale-price') : null;

      var card = buildCard({
        imgSrc: imgEl ? imgEl.src : '',
        imgAlt: imgEl ? imgEl.alt : '',
        name: titleNode ? titleNode.textContent.trim() : '',
        price: priceNode ? priceNode.textContent.trim() : '',
        variantCont: variantCont,
        checkboxInput: checkboxInput,
        isDisabled: isDisabled,
        isChecked: isChecked
      });
      if (!isDisabled) card.classList.add('btpro-card--offer');
      cardEls.push(card);
      cardGrid.appendChild(card);

      // "+" sadece trigger (i=0) ile offer arasına
      if (i === 0) {
        var plus = document.createElement('div');
        plus.className = 'btpro-bundle-plus';
        plus.innerHTML = PLUS_SVG;
        cardGrid.appendChild(plus);
      }
    });

    var discountEl = ctaHost ? ctaHost.querySelector('.lb-price-discount') : null;
    var totalSaleEl = ctaHost ? ctaHost.querySelector('.lb-price-sale-price') : null;
    var addToCartBtn = ctaHost ? ctaHost.querySelector('.lb-button') : null;
    var selectedCount = Array.from(infoItems).filter(function (item) {
      return item.querySelector('.lb-custom-checkbox.lb-checked');
    }).length;

    var discountText = (discountEl ? discountEl.textContent.trim() : '10%') + ' ' + t('bundleDiscount');
    var panel = buildDiscountPanel({
      discountText: discountText,
      selectedCount: selectedCount,
      totalPrice: totalSaleEl ? totalSaleEl.textContent.trim() : '',
      btnEl: addToCartBtn,
      bundle: bundle
    });

    insertLayout(classicEl, cardGrid, panel, bundle, infoItems, cardEls, ctaHost);
    return true;
  }

  // -------------------------------------------------------------------
  // TİP 2: lb-tgrid
  // -------------------------------------------------------------------
  function applyTgridDesign(bundle) {
    var allCardHosts = bundle.querySelectorAll('lb-upsell-long-card');
    var productsCont = bundle.querySelector('.lb-bundle-products-cont.lb-tgrid');
    var ctaHost = bundle.querySelector('lb-bundle-cta');

    if (!allCardHosts.length || !productsCont) {
      setTimeout(function () { applyBundleDesign(bundle); }, 300);
      return false;
    }

    var cardGrid = document.createElement('div');
    cardGrid.className = 'btpro-bundle-card-grid';
    var cardEls = [];

    allCardHosts.forEach(function (cardHost, i) {
      // i===0 her zaman trigger/ana üründür; .lb-bundle-tgrid-trigger DOM kontrolü yedek
      var isTrigger = i === 0 || !!cardHost.closest('.lb-bundle-tgrid-trigger');
      var checkboxInput = cardHost.querySelector('input[type="checkbox"]');
      var isChecked = !!cardHost.querySelector('.lb-custom-checkbox.lb-checked');
      var imgEl = cardHost.querySelector('img');
      var titleNode = cardHost.querySelector('.lb-card-title');
      var variantCont = cardHost.querySelector('.lb-variant-picker-cont');
      var priceNode = cardHost.querySelector('.lb-price-sale-price');

      var card = buildCard({
        imgSrc: imgEl ? imgEl.src : '',
        imgAlt: imgEl ? imgEl.alt : '',
        name: titleNode ? titleNode.textContent.trim() : '',
        price: priceNode ? priceNode.textContent.trim() : '',
        variantCont: variantCont,
        checkboxInput: checkboxInput,
        isDisabled: isTrigger,
        isChecked: isTrigger ? true : isChecked
      });
      if (!isTrigger) card.classList.add('btpro-card--offer');
      cardEls.push(card);
      cardGrid.appendChild(card);

      // "+" sadece trigger'dan (i=0) sonra bir kez
      if (i === 0) {
        var plus = document.createElement('div');
        plus.className = 'btpro-bundle-plus';
        plus.innerHTML = PLUS_SVG;
        cardGrid.appendChild(plus);
      }
    });

    // Aktif tier'dan indirim metnini al
    var activePill = bundle.querySelector('.lb-bundle-discountText-pills.lb-selected-tier');
    var totalSaleEl = ctaHost ? ctaHost.querySelector('.lb-price-sale-price') : null;
    var addToCartBtn = ctaHost ? ctaHost.querySelector('.lb-button') : null;
    var discountEl = ctaHost ? ctaHost.querySelector('.lb-price-discount') : null;

    var rawDiscount = activePill
      ? activePill.textContent.trim()
      : (discountEl ? discountEl.textContent.trim() : '10%');
    var discountText = rawDiscount + '<br>' + t('bundleDiscount');

    var infoItems = bundle.querySelectorAll('lb-upsell-long-card');
    var selectedCount = Array.from(infoItems).filter(function (item) {
      return item.querySelector('.lb-custom-checkbox.lb-checked') || item.closest('.lb-bundle-tgrid-trigger');
    }).length;

    var panel = buildDiscountPanel({
      discountText: discountText,
      selectedCount: selectedCount,
      totalPrice: totalSaleEl ? totalSaleEl.textContent.trim() : '',
      btnEl: addToCartBtn,
      bundle: bundle
    });

    insertLayout(productsCont, cardGrid, panel, bundle, infoItems, cardEls, ctaHost);
    return true;
  }

  // -------------------------------------------------------------------
  // Ana giriş: tip tespiti
  // -------------------------------------------------------------------
  function applyBundleDesign(bundle) {
    if (bundle.dataset.btproStyled) return;

    var cont = bundle.querySelector('.lb-bundle-cont');
    if (!cont) return;

    var isClassic = cont.classList.contains('lb-classic');
    var isTgrid = cont.classList.contains('lb-tgrid');

    if (!isClassic && !isTgrid) {
      setTimeout(function () { applyBundleDesign(bundle); }, 300);
      return;
    }

    bundle.dataset.btproStyled = 'true';
    bundle.style.outline = '';

    cont.removeAttribute('style');
    cont.classList.add('btpro-bundle-cont');

    var headerCont = bundle.querySelector('.lb-bundle-header-cont');
    if (headerCont) headerCont.classList.add('btpro-bundle-header');

    var ok = isClassic ? applyClassicDesign(bundle) : applyTgridDesign(bundle);

    // Eğer iç içerik hazır değilse flag'i sıfırla, tekrar denensin
    if (!ok) {
      delete bundle.dataset.btproStyled;
    }
  }

  // -------------------------------------------------------------------
  // Seçim değişikliklerini izle
  // -------------------------------------------------------------------
  function observeSelectionChanges(bundle, panel, infoItems, cardEls, ctaHost) {
    var countEl = panel.querySelector('.btpro-discount-count');
    var priceEl = panel.querySelector('.btpro-discount-total-price');
    var priceFixer = createPriceFixer(panel, cardEls, infoItems);

    function getCurrentBadgeText() {
      var activePill = bundle.querySelector('.lb-bundle-discountText-pills.lb-selected-tier');
      var discountEl = ctaHost ? ctaHost.querySelector('.lb-price-discount') : null;
      var rawDiscount = activePill
        ? activePill.textContent.trim()
        : (discountEl ? discountEl.textContent.trim() : null);
      if (!rawDiscount) return null;
      var isTgrid = !!bundle.querySelector('.lb-tgrid');
      return isTgrid
        ? rawDiscount + '<br>' + t('bundleDiscount')
        : rawDiscount + ' ' + t('bundleDiscount');
    }

    function updateBadges(text) {
      if (!text) return;
      var desktopBadge = panel.querySelector('.btpro-discount-badge');
      if (desktopBadge) desktopBadge.innerHTML = text;
      if (panel._headerEl) {
        var mobileBadge = panel._headerEl.querySelector('.btpro-discount-badge');
        if (mobileBadge) mobileBadge.innerHTML = text;
      }
    }

    function update() {
      // i===0 da trigger sayılır (her iki bundle tip için güçlendirilmiş tespit)
      var count = Array.from(infoItems).filter(function (item, i) {
        return i === 0 || item.querySelector('.lb-custom-checkbox.lb-checked') || item.closest('.lb-bundle-tgrid-trigger');
      }).length;

      if (countEl) countEl.textContent = t('productsSelected', count);

      // Duzeltme aktifse toplami kendimiz hesapliyoruz; eklentininki eski varyantta takili kalir.
      var livePrice = ctaHost ? ctaHost.querySelector('.lb-price-sale-price') : null;
      if (priceEl && livePrice && !priceFixer.isActive()) priceEl.textContent = livePrice.textContent.trim();

      // Aktif tier değişince badge'i güncelle (10% → 15% gibi)
      var badgeText = getCurrentBadgeText();
      if (badgeText) updateBadges(badgeText);

      infoItems.forEach(function (item, i) {
        var card = cardEls[i];
        if (!card) return;

        // Eklenti kartı yeniden render ederse yeni bir picker doğar; onu da karta taşı,
        // aksi halde eski (kopuk) picker ekranda kalır ve fiyat güncellenmez.
        var strayPicker = item.querySelector('.lb-variant-picker-cont');
        var pickerWrap = card.querySelector('.btpro-bundle-card-picker');
        if (strayPicker && pickerWrap && strayPicker.parentElement !== pickerWrap) {
          pickerWrap.innerHTML = '';
          pickerWrap.appendChild(strayPicker);
        }

        // Kart fiyatını güncelle
        var liveItemPrice = item.querySelector('.lb-price-sale-price');
        var cardPriceEl = card.querySelector('.btpro-bundle-card-price');
        if (liveItemPrice && cardPriceEl && !priceFixer.isActive()) {
          cardPriceEl.textContent = liveItemPrice.textContent.trim();
        }

        // i===0 veya btpro-card--trigger classı varsa trigger kabul et
        var isTrigger = i === 0 || card.classList.contains('btpro-card--trigger');
        if (isTrigger) return;
        var checked = !!item.querySelector('.lb-custom-checkbox.lb-checked');
        var overlay = card.querySelector('.btpro-card-check-overlay');
        card.classList.toggle('btpro-card--unchecked', !checked);
        if (overlay) overlay.classList.toggle('btpro-card-check-overlay--checked', checked);
      });

      priceFixer.apply();
    }

    update();

    var mo = new MutationObserver(update);
    infoItems.forEach(function (item) {
      // class + text içeriği değişimlerini yakala (fiyat güncellemeleri için)
      mo.observe(item, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true, characterData: true });
    });
    if (ctaHost) mo.observe(ctaHost, { childList: true, subtree: true, characterData: true });

    // Tgrid tier pill'larını da izle (lb-selected-tier class değişimi)
    bundle.querySelectorAll('[class*="lb-bundle-discountText"]').forEach(function (pill) {
      mo.observe(pill, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // -------------------------------------------------------------------
  // Varyant fiyat duzeltmesi
  // -------------------------------------------------------------------
  // Selleasy widget'i beden degisince kart fiyatini ve toplami guncellemiyor (eklentinin
  // kendi arayuzunde de ayni). Sepete dogru varyant ve dogru fiyat gidiyor, sadece ekranda
  // eski fiyat kaliyor. Burada secili varyantin gercek fiyatini Shopify'dan okuyup yaziyoruz.
  var VariantPrices = (function () {
    var map = {};
    var ready = false;
    var queue = [];
    var started = false;

    // Sadece urun handle'lari toplanir: kampanya trigger'i koleksiyon olabiliyor ve o handle
    // /products/<handle>.js olarak istenince 404 doner. Ayrica "Shopify recommendations"
    // modunda offer urunleri lbValidOffers'ta bulunmaz — onlari widget DOM'undaki
    // urun linklerinden cikariyoruz.
    function handles() {
      var out = [];

      function collect(source) {
        if (!source || source.type !== 'product') return;
        (source.values || []).forEach(function (v) { if (v.handle) out.push(v.handle); });
      }

      (window.lbValidOffers || []).forEach(function (offer) {
        collect(offer.triggers);
        (offer.offerBlocks || []).forEach(collect);
      });

      document.querySelectorAll('lb-bundle a[href*="/products/"]').forEach(function (link) {
        var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (match) out.push(match[1]);
      });

      return out.filter(function (h, i, arr) { return arr.indexOf(h) === i; });
    }

    function load() {
      if (started) return;
      started = true;
      var list = handles();
      if (!list.length) return;

      Promise.all(list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        products.forEach(function (product) {
          if (!product || !product.variants) return;
          product.variants.forEach(function (v) { map[v.id] = v.price; });
        });
        ready = true;
        queue.forEach(function (fn) { fn(); });
        queue = [];
      });
    }

    return {
      init: load,
      get: function (id) { return map[id]; },
      all: function () { return map; },
      isReady: function () { return ready; },
      onReady: function (fn) { if (ready) fn(); else queue.push(fn); }
    };
  })();

  // "QAR 1.100,74" / "SAR 216.00" gibi metinlerden sayiyi cikarir.
  function parseMoney(text) {
    var match = String(text || '').match(/[\d][\d.,\s\u00A0]*/);
    if (!match) return null;
    var raw = match[0].replace(/[\s\u00A0]/g, '');
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var decSep = lastDot > lastComma ? '.' : (lastComma > -1 ? ',' : null);
    var normalized = raw;
    if (decSep) {
      var groupSep = decSep === '.' ? ',' : '.';
      normalized = raw.split(groupSep).join('').replace(decSep, '.');
    }
    var value = parseFloat(normalized);
    return isNaN(value) ? null : value;
  }

  // Sayiyi, ornek metnin para birimi ve ayirici duzenini koruyarak yazar.
  function formatMoneyLike(value, template) {
    var match = String(template || '').match(/[\d][\d.,\s\u00A0]*/);
    if (!match) return String(value);
    var sample = match[0];
    var decSep = sample.lastIndexOf('.') > sample.lastIndexOf(',') ? '.' : ',';
    var groupSep = decSep === '.' ? ',' : '.';
    var useGroup = sample.indexOf(groupSep) !== -1 || value >= 1000;
    var parts = value.toFixed(2).split('.');
    var intPart = useGroup ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep) : parts[0];
    return String(template).replace(sample, intPart + decSep + parts[1]);
  }

  function createPriceFixer(panel, cardEls, infoItems) {
    var templates = [];   // her kartin ilk (dogru) fiyat metni — format ornegi
    var rate = null;      // magaza para birimi -> gosterilen para birimi katsayisi

    function shopPrice(card) {
      var select = card.querySelector('select');
      var id = select ? parseInt(select.value, 10) : NaN;
      if (isNaN(id)) return null;
      var cents = VariantPrices.get(id);
      return typeof cents === 'number' ? cents / 100 : null;
    }

    // Ilk render'daki fiyat dogru; ondan kur katsayisini cikariyoruz, cunku /products/x.js
    // magaza para birimini (USD) dondururken widget piyasa para birimini gosteriyor.
    function calibrate() {
      cardEls.forEach(function (card, i) {
        var el = card.querySelector('.btpro-bundle-card-price');
        if (!el) return;
        if (templates[i] === undefined) templates[i] = el.textContent.trim();
        if (rate != null) return;
        var shown = parseMoney(templates[i]);
        var base = shopPrice(card);
        if (shown && base) rate = shown / base;
      });
    }

    function apply() {
      calibrate();
      if (rate == null) return;

      var total = 0;
      var wrote = false;

      cardEls.forEach(function (card, i) {
        var el = card.querySelector('.btpro-bundle-card-price');
        var base = shopPrice(card);
        if (!el || base == null || !templates[i]) return;

        var price = base * rate;
        el.textContent = formatMoneyLike(price, templates[i]);
        wrote = true;

        var item = infoItems[i];
        var isSelected = i === 0 || !card.classList.contains('btpro-card--unchecked') ||
          !!(item && item.querySelector('.lb-custom-checkbox.lb-checked'));
        if (isSelected) total += price;
      });

      var totalEl = panel.querySelector('.btpro-discount-total-price');
      if (wrote && totalEl && total > 0) {
        // Kart fiyatlari zaten indirimli (sale price) — toplama ayrica indirim uygulanmaz.
        var template = totalEl.textContent.trim() || templates[0];
        totalEl.textContent = formatMoneyLike(total, template);
      }
    }

    VariantPrices.init();

    // Teshis kancasi: konsoldan window.__btproPriceFix ile ic duruma bakilabilir.
    window.__btproPriceFix = {
      state: function () {
        return {
          ready: VariantPrices.isReady(),
          knownVariants: Object.keys(VariantPrices.all()).length,
          rate: rate,
          templates: templates,
          cards: cardEls.map(function (card) {
            var select = card.querySelector('select');
            return {
              selects: card.querySelectorAll('select').length,
              value: select ? select.value : null,
              selectedText: select && select.selectedIndex >= 0 ? select.options[select.selectedIndex].textContent.trim() : null,
              shopPrice: shopPrice(card),
              shown: (card.querySelector('.btpro-bundle-card-price') || {}).textContent
            };
          })
        };
      },
      apply: function () { VariantPrices.onReady(apply); return this.state(); }
    };

    // Tetikleme: eklenti select'in change olayini kendi icinde durduruyor, bu yuzden
    // capture fazinda (hedefe inmeden once) dinliyoruz.
    ['change', 'input'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var target = e.target;
        if (!target || target.tagName !== 'SELECT') return;
        if (!target.closest('.btpro-bundle-card')) return;
        VariantPrices.onReady(apply);
      }, true);
    });

    // Guvence: eklenti secimi kendi kodundan degistirirse olay hic dogmayabilir.
    // Secili varyantlari hafifce yoklayip degisince yaziyoruz.
    var lastSignature = '';
    setInterval(function () {
      var signature = cardEls.map(function (card) {
        var select = card.querySelector('select');
        return select ? select.value : '';
      }).join('|');
      if (signature === lastSignature) return;
      lastSignature = signature;
      VariantPrices.onReady(apply);
    }, 400);

    return {
      apply: function () { VariantPrices.onReady(apply); },
      isActive: function () { return rate != null; }
    };
  }

  // -------------------------------------------------------------------
  // DOM izleme
  // -------------------------------------------------------------------
  function waitForHydration(bundleEl) {
    if (bundleEl.classList.contains('hydrated')) {
      setTimeout(function () { applyBundleDesign(bundleEl); }, 150);
      return;
    }
    var mo = new MutationObserver(function () {
      if (bundleEl.classList.contains('hydrated')) {
        mo.disconnect();
        setTimeout(function () { applyBundleDesign(bundleEl); }, 150);
      }
    });
    mo.observe(bundleEl, { attributes: true, attributeFilter: ['class'] });
  }

  function watchForBundle() {
    document.querySelectorAll('lb-bundle').forEach(waitForHydration);

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (mut) {
        mut.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'LB-BUNDLE') waitForHydration(node);
          if (node.querySelectorAll) node.querySelectorAll('lb-bundle').forEach(waitForHydration);
        });
        if (mut.type === 'attributes' && mut.target.tagName === 'LB-BUNDLE') {
          waitForHydration(mut.target);
        }
      });
    });

    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForBundle);
  } else {
    watchForBundle();
  }
})();
